import React from 'react';
import { Header } from '../Header';
import { Outlet } from 'react-router-dom';

export function ManageBookingLayout({ children }: React.PropsWithChildren) {
    return <div className='bg-gray-50 flex flex-col min-h-dvh'>
        <Header hideCloseButton={true} />
        <main className='max-w-2xl w-full mx-auto p-5 my-20 flex-1 flex flex-col overflow-hidden'>
            <Outlet />
            {children}
        </main>
    </div>
}